<template>
  <aside :class="styleMain">
    <team-header :match="match" :team="team" />
    <div class="content">
      <team-buttons :match="match" :team="team" />
      <team-statistics :match="match" :team="team" />
    </div>
  </aside>
</template>

<script>
import TeamHeader from './team/TeamHeader'
import TeamButtons from './team/TeamButtons'
import TeamStatistics from './team/TeamStatistics'

export default {
  name: 'SportFootballMatchTeam',
  components: { TeamButtons, TeamHeader, TeamStatistics },
  data () {
    return {
      styleLoaded: null
    }
  },
  props: {
    match: Object,
    teamId: Number
  },
  computed: {
    team () { return this.$store.getters['Sport/Football/Team/team'](this.teamId) },
    styleMain () { return ['sportFootballMatchTeam', this.match?.homeAway(this.team), this.styleLoaded] }
  },
  updated () {
    this.styleLoaded = 'loaded'
  }
}
</script>

<style>
.sportFootballMatchTeam {
  flex:0 0 auto;
  min-height: 100%;
  min-width: 300px;
  width: 390px;
  transition-duration: 1s;
  transition-property: opacity;
  opacity: 0;
  display:flex;
  flex-direction: column;
}
.sportFootballMatchTeam.loaded{
  opacity: 1;
}
.sportFootballMatchTeam.home {
  background: linear-gradient(180deg, var(--color-team-home) 50%, black 160%)
}

.sportFootballMatchTeam.away {
  background: linear-gradient(180deg, var(--color-team-away) 50%, black 160%)
}
.sportFootballMatchTeam > .content{
  flex: 1 1 auto;
  overflow-y: auto
}
</style>
